import {
  Container,
  Typography,
  TextField,
  Collapse,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import OpenList from "../component/OrderList";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useErrValidate } from "../utilitis/AuthorizationPage";
import { RolesContext } from "../context/User";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SearchIcon from "@mui/icons-material/Search";
import CustomCard from "../styleComp/CustomCard";

export default function OpenOrders() {
  const { validationPage } = useErrValidate();
  const [todate, settoDate] = useState("");
  const [fromdate, setfromDate] = useState("");
  const [ivnum, setIvnum] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [data, setData] = useState();
  const [stateroles, dispatchroles] = useContext(RolesContext);

  useEffect(() => {
    validationPage("openorder");
  }, [stateroles.userId]);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const SearchData = () => {
    setClicked(clicked == true ? false : true);
    setData({ todate: todate, fromdate: fromdate, ivnum: ivnum });
    setIvnum("");
    // setfromDate("");
    // settoDate("");
  };

  const handlefromdateChange = (event) => {
    setfromDate(event.target.value);
  };

  const handletodateChange = (event) => {
    settoDate(event.target.value);
  };

  const handleIvnum = (event) => {
    setIvnum(event.target.value);
  };

  return (
    <Container maxWidth="100%">
      <Box sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }}>
        <CustomCard overflowCard={"scroll"}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginTop: "1rem" }}
          >
            <Typography variant="h4">הזמנות</Typography>{" "}
            <Toolbar>
              <TextField
                sx={{ marginRight: "1rem" }}
                label="מספר הזמנה"
                type="text"
                variant="outlined"
                value={ivnum}
                onChange={handleIvnum}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <TextField
                label="מ- תאריך"
                type="date"
                variant="outlined"
                value={fromdate}
                onChange={handlefromdateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <TextField
                sx={{ marginLeft: "1rem" }}
                label="עד- תאריך"
                type="date"
                variant="outlined"
                value={todate}
                onChange={handletodateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <Button
                endIcon={<SearchIcon />}
                sx={{
                  marginLeft: "3rem",
                  padding: "1rem",
                  paddingLeft: "1rem",
                }}
                onClick={SearchData}
              >
                חיפוש
              </Button>
            </Toolbar>
          </Grid>
          <br />
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <OpenList clicked={clicked} data={data} />
          </Grid>
        </CustomCard>
      </Box>
      <Box sx={{ flexGrow: 1, display: { xs: "block", md: "none" } }}>
        <Typography variant="h4">הזמנות פתוחות</Typography>{" "}
        <Button
          sx={{ color: "black",marginBottom: "1rem" }}
          startIcon={<ManageSearchIcon />}
          onClick={handleExpand}
          size="large"
        ></Button>
        <Collapse in={expanded}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12}>
              <TextField
                sx={{ marginRight: "1rem" }}
                label="מספר הזמנה"
                type="text"
                variant="outlined"
                value={ivnum}
                onChange={handleIvnum}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size="small"
                label="מ- תאריך"
                type="date"
                variant="outlined"
                value={fromdate}
                onChange={handlefromdateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ marginTop: "0.5rem" }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size="small"
                sx={{ marginTop: "0.5rem" }}
                label="עד- תאריך"
                type="date"
                variant="outlined"
                value={todate}
                onChange={handletodateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                endIcon={<SearchIcon />}
                size="large"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                onClick={SearchData}
              >
                חיפוש
              </Button>
            </Grid>
          </Grid>
        </Collapse>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <OpenList clicked={clicked} data={data} />
        </Grid>
      </Box>
    </Container>
  );
}
